import type { SendbirdGroupChannel } from '@sendbird/uikit-utils';
import type { TChannelTitleLabels } from '../types';
import { getChannelKind } from './channelType';

export const getChannelTitle = (
    channel: Pick<SendbirdGroupChannel, 'name' | 'customType'>,
    labels: TChannelTitleLabels,
): string => {
    switch (getChannelKind(channel)) {
        case 'technicalSupport':
            return labels.technicalSupport;
        case 'clinical':
            return labels.team;
        default:
            return channel.name;
    }
};
